import { FC, useState } from 'react'
import { Modal } from '../Modal'

interface ProjectUpdateImgModalInterface {
  projectUpdateImgThumbnail?: string
  projectUpdateImgAltTagThumbnail?: string
  projectUpdateImgLarge?: string
  projectUpdateImgAltTagLarge?: string
}

export const ProjectUpdateImgModal: FC<ProjectUpdateImgModalInterface> = ({
  projectUpdateImgAltTagThumbnail,
  projectUpdateImgThumbnail,
  projectUpdateImgAltTagLarge,
  projectUpdateImgLarge
}) => {
  const [show, setShow] = useState<boolean>(false)
  if (projectUpdateImgLarge) {
    return (
      <>
        <Modal
          isOpen={show}
          handleClose={() => {
            setShow(false)
          }}
          title=""
          maxWidth={500}
        >
          <img
            src={projectUpdateImgLarge}
            alt={projectUpdateImgAltTagLarge}
            width="100%"
          />
        </Modal>
        <button
          className="img-container mt-0 mb-8 md:mb-0 md:mt-16 cursor-pointer rounded"
          onClick={() => {
            setShow(true)
          }}
        >
          <img
            src={projectUpdateImgThumbnail}
            className="img-responsive"
            alt={projectUpdateImgAltTagThumbnail}
          />
        </button>
      </>
    )
  }
  return (
    <div
      className="img-container mt-0 mb-8 md:mb-0 md:mt-16 bg-primary-blue-light flex items-center justify-center rounded"
      style={{ minHeight: 150 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 81.431 60"
        width="40%"
        style={{ maxWidth: '100px' }}
      >
        <path
          fill="#fff"
          fillOpacity="75%"
          d="M79.747 56.639h-4.439v-22.66h2.908a1.684 1.684 0 0 0 1.684-1.684V13.927a1.683 1.683 0 0 0-1.684-1.682h-9.031v-3.08a4.745 4.745 0 1 0-3.367 0v3.08H15.613v-3.08a4.745 4.745 0 1 0-3.367 0v3.08H3.215a1.682 1.682 0 0 0-1.684 1.682v18.368a1.683 1.683 0 0 0 1.684 1.684h2.908v22.66H1.684a1.683 1.683 0 1 0 0 3.366h18.368a1.683 1.683 0 1 0 0-3.366h-4.439v-22.66h50.205v22.66h-4.443a1.683 1.683 0 1 0 0 3.366h18.368a1.683 1.683 0 1 0 0-3.366ZM67.502 3.371a1.378 1.378 0 1 1-1.378 1.378 1.38 1.38 0 0 1 1.378-1.383Zm-53.573 0a1.378 1.378 0 1 1-1.378 1.378 1.38 1.38 0 0 1 1.378-1.383Zm59.7 27.247h-3.288l6.2-11.357v11.357Zm-67.479 0 8.751-15h6.814l-8.751 15H6.15Zm19.465-15h6.814l-8.751 15h-6.814Zm10.715 0h6.814l-8.751 15h-6.818Zm10.715 0h6.814l-8.751 15h-6.814Zm10.715 0h6.814l-8.751 15h-6.814Zm10.714 0h6.215l-8.183 15h-6.782Zm-57.473 0-6.1 10.456V15.611Zm1.244 41.021H9.49v-22.66h2.755Zm56.94 0v-22.66h2.755v22.66Z"
        />
      </svg>
    </div>
  )
}

export default ProjectUpdateImgModal
